import { ComponentsManager } from '../core/smpl-components'
// import { componentRegistry } from '../config/components-registry'

import ComponentBody from '../components/body'
import ComponentLandscapeSlider from '../components/landscape-slider'
import ComponentMainNav from '../components/main-nav'
import ComponentAccordion from '../components/accordion'
import ComponentPageHero from '../components/page-hero'
import ComponentAnimationScroller from '../components/animation-scroller'
import ComponentVideoEmbed from '../components/video-embed'
import ComponentVideoOverlay from '../components/video-overlay'
import ComponentBunnyPlayer from '../components/bunny-player'
import ComponentScrollReveal from '../components/scroll-reveal'
import ComponentScrollParallax from '../components/scroll-parallax'
import ComponentLanguageSelect from '../components/language-select'
import ComponentExternalVideo from '../components/video-external'
import ComponentExternalVideoPlayer from '../components/external-video-player'

const componentRegistry = [
	{
		selector: '.js-page-hero',
		name: 'page-hero',
		loader: () => ComponentPageHero,
	},
	{
		selector: 'body',
		name: 'body',
		loader: () => ComponentBody,
	},
	{
		selector: '.js-landscape-slider',
		name: 'landscape-slider',
		loader: () => ComponentLandscapeSlider,
	},
	{
		selector: '.js-main-nav',
		name: 'main-nav',
		loader: () => ComponentMainNav,
	},
	{
		selector: '.js-accordion',
		name: 'accordion',
		loader: () => ComponentAccordion,
	},
	{
		selector: '.js-animation-scroller',
		name: 'animation-scroller',
		loader: () => ComponentAnimationScroller,
	},
	{
		selector: '.js-video-embed',
		name: 'video-embed',
		loader: () => ComponentVideoEmbed,
	},
	{
		selector: '.js-video-overlay',
		name: 'video-overlay',
		loader: () => ComponentVideoOverlay,
	},
	{
		selector: '.js-external-video',
		name: 'video-external',
		loader: () => ComponentExternalVideo,
	},
	{
		selector: 'body',
		name: 'scroll-parallax',
		loader: () => ComponentScrollParallax,
	},
	{
		selector: 'body',
		name: 'scroll-reveal',
		loader: () => ComponentScrollReveal,
	},
	{
		selector: '.js-language-select',
		name: 'language-select',
		loader: () => ComponentLanguageSelect,
	},
	{
		selector: '.js-external-video-player',
		name: 'external-video-player',
		loader: () => ComponentExternalVideoPlayer,
	},
	{
		selector: '.js-bunny-player',
		name: 'bunny-player',
		loader: () => ComponentBunnyPlayer,
	},
]

// ...existing code...
export const initComponents = (ctx) => {
	ComponentsManager.setup({
		debug: true,
		components: componentRegistry,
		eventBus: ctx.eventBus,
	})

	// window.ComponentsManager = ComponentsManager
	ctx.componentsManager = ComponentsManager

	//
	// document.addEventListener(
	//     'DOMContentLoaded',
	//     () => {
	//         manager.init()
	//     },
	//     { once: true }
	// )

	return ComponentsManager
}
